import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Students from "@/pages/Students";
import StudentDetail from "@/pages/StudentDetail";
import Trainers from "@/pages/Trainers";
import TrainerDetail from "@/pages/TrainerDetail";
import Attendance from "@/pages/Attendance";
import Payments from "@/pages/Payments";
import Schedule from "@/pages/Schedule";
import Slots from "@/pages/Slots";
import Reports from "@/pages/Reports";
import InvoicePage from "@/pages/InvoicePage";

function AdminRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="label-tag animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function ManagerOrAdminRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="label-tag animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user || (user.role !== "admin" && user.role !== "manager")) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/students/:id/invoice" element={<InvoicePage />} />
            <Route element={<AppLayout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/students" element={<Students />} />
              <Route path="/students/:id" element={<StudentDetail />} />
              <Route path="/trainers" element={<ManagerOrAdminRoute><Trainers /></ManagerOrAdminRoute>} />
              <Route path="/trainers/:id" element={<ManagerOrAdminRoute><TrainerDetail /></ManagerOrAdminRoute>} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/reports" element={<ManagerOrAdminRoute><Reports /></ManagerOrAdminRoute>} />
              <Route path="/payments" element={<AdminRoute><Payments /></AdminRoute>} />
              <Route path="/slots" element={<ManagerOrAdminRoute><Slots /></ManagerOrAdminRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
